import { request } from "./http";

export interface Fill {
  id: string;
  order_id: string | null;
  trading_account_id: string | null;
  symbol: string;
  side: string;
  quantity: string;
  price: string;
  commission: string;
  venue: string | null;
  timestamp: string;
}

export interface FillsQuery {
  trading_account_id?: string;
  from_ts?: string;
  to_ts?: string;
  symbol?: string;
  venue?: string;
  limit?: number;
}

export const fills = {
  list: (q: FillsQuery = {}) => {
    const p = new URLSearchParams();
    for (const [k, v] of Object.entries(q)) {
      if (v !== undefined && v !== null && v !== "") p.set(k, String(v));
    }
    const qs = p.toString();
    return request<Fill[]>(`/piggy/api/fills${qs ? `?${qs}` : ""}`);
  },
};
